import { Alert, Box, IconButton, Snackbar, Stack, Table, TableCell, TableContainer, TableRow, tableCellClasses, Typography, Button, Radio } from "@mui/material";
import { map } from "../types/Map";
import { useEffect, useState } from "react";
import { getWindowSize, isTablet } from "../utils/browserDetails";
import { TaskData, TaskFrequency, TaskRecord, TaskStatus } from "../types/Task";
import { addTask, startTask } from "../api/task";
import { DatePicker, LocalizationProvider, MobileTimePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import de from 'date-fns/locale/de';
import { CollectionsOutlined, Sensors } from "@mui/icons-material";
import { RobotDetailData, RobotMode } from "../types/Robot";
import { TaskCollectionType, TaskRecordCollectionData, TaskRecordCollectionSendData } from "../types/TaskCollection";
import { createTaskCollection } from "../api/taskCollection";

export const CompartmentJob = (props: {
    currentMap: map,
    currentLocation: number,
    currentLocationName: string,
    handleTaskRecordCreation: (taskRecord: TaskRecord) => void,
    robotData: RobotDetailData | undefined,
    shouldDisableCall: boolean,
    setConfig: (obj : {[id : number]: string}) => void,
    robotConf: {[id : number]: string | undefined},
    changeState: (id: number) => void,
    changeLocalstate: (stateId: number) => void,
    handleTaskRecordCollectionCreation: (taskRecordCollector: TaskRecordCollectionData) => void,
    handleLoadingStart: () => void,
    handleLoadingEnd: () => void,
    handleLocationSelection: (locatino: string) => void,
}) => {
    const { currentMap, 
        currentLocation, 
        currentLocationName, 
        handleTaskRecordCreation,
        handleTaskRecordCollectionCreation,
        handleLoadingStart,
        handleLoadingEnd,
        robotData,
        shouldDisableCall,
        setConfig,
        changeState,
        robotConf,
        changeLocalstate} = props
    const [taskDate, setTaskDate] = useState<Date>(new Date())
    const [taskTime, setTaskTime] = useState<Date>(new Date())
    const [taskRepeatDays, setTaskRepeatDays] = useState<number>(0);
    const [width, setWidth] = useState<number>(getWindowSize().width);
    const [success, setSuccess] = useState<boolean>(false);
    const [failed, setFailed] = useState<boolean>(false);
    const [frequency, setFrequency] = useState<TaskFrequency>(TaskFrequency.NEVER);
    const [clicked, setClicked] = useState<boolean>(false);

    const [selectedTimeWait, setSelectedTimeWait] = useState<string>("inf")
    const [selectedWard, setSelectedWard] = useState<string>("WARD 14F")

    useEffect(() => {
        setConfig({"0": "WARD 14F"})
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
          };
      
          window.addEventListener('resize', handleWindowResize);
      
          return () => {
            window.removeEventListener('resize', handleWindowResize);
          };
    }, [])

    useEffect(() => {
    }, [success, failed])

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }
        setSuccess(false);
        setFailed(false);
      };


    const getLocationFromDisplay = () => {
        // TODO: create logic to append locations properly
        // if(selectedWard === "WARD 14F") {
        //     return 60
        // } else if (selectedWard === "WARD 11F") {
        //     return 55
        // }
        if (0 in robotConf && robotConf[0] !== undefined) {
            return robotConf[0] === "WARD 14F" ? 60 : 55
        }

        if (1 in robotConf && robotConf[1] !== undefined) {
            return robotConf[1] === "WARD 14F" ? 60 : 55
        }
        return 60
    }

    const getCompartmentIndex = () => {
        let index = 0
        if (0 in robotConf && robotConf[0] !== undefined) {
            index |= 3
        }

        if (1 in robotConf && robotConf[1] !== undefined) {
            index |= 12
        }

        return index
    } 

    const handleSubmit = async () => {
        // eslint-disable-next-line no-restricted-globals
        event?.preventDefault()
        if (!robotData || (selectedWard !== "WARD 14F" && selectedWard !== "WARD 11F")){
            setFailed(true);
            return;
        }
        handleLoadingStart() // udpate main page is loading start
        const taskCollectionData = {
            "name": "New Task at " + currentLocationName,
            "status": TaskStatus.QUEUED,
            "taskRecords": [],
            "sourceLocation": currentLocation,
            "createdDatetime": new Date(),
            "targetLocation": getLocationFromDisplay(),
            "taskCollectionType": TaskCollectionType.STANDARD_JOB,
            "compartmentIndex": getCompartmentIndex(),
            "waitTime": selectedTimeWait === "10" ? "00:10:00" : null
        } as TaskRecordCollectionSendData;
        setConfig({})
        console.log(taskCollectionData)

        try{
            // TODO: precreate tasks and hard code here
            const result = await createTaskCollection(taskCollectionData);
            handleTaskRecordCollectionCreation(result.data as TaskRecordCollectionData)
            // console.log(result);
            // const startTaskResult = await startTask({
            //     task_id: result.data.id,
            //     robot: robotData.id,
            // });
            // // console.log(startTaskResult.data);
            // setSuccess(true);
            // handleTaskRecordCreation(startTaskResult.data); // has to have id here
        } catch(e) {
            // console.log(e);
            setFailed(true);
        }
        handleLoadingEnd() // update main page loading end
    }

    const handleOnClickRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (selectedTimeWait === event.target.value) {
            setSelectedTimeWait("");
        } else {
            setSelectedTimeWait(event.target.value);
        }
    }

    const handleOnClickWard = (value: string) => {
        console.log(value + " vs " + selectedWard)
        if(selectedWard === value) {
            // props.handleLocationSelection("")
            // setSelectedWard("")
            console.log("Do not unselect")
        } else {
            props.handleLocationSelection(value)
            setSelectedWard(value)
        }
        
    }

    const handleOnClickProceed = () => {
        console.log("TODO: change to submit job and job settings")
        // send request to RMF directly to a location with the following commmand
        // ros2 rmf_demos dispatch_go_to_place destination
        changeState(1) // 1 is queue page
        if(selectedTimeWait === "10") {
            changeLocalstate(0)
        } else {
            changeLocalstate(1)
        }
    }

    return <>
        
        <Box sx={{
            backgroundColor: "#eae6d0",
            height: "128px",
        }}>
            <Stack direction={"row"}>
                <Box sx={{
                    width: "85%"
                }}>
                    <Typography sx={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    paddingLeft: "20px",
                    // paddingBottom: "6px",
                    paddingTop: "12px",
                }}>Create a delivery</Typography>
                <Typography sx={{
                    fontSize: "22px",
                    paddingLeft: "20px",
                    paddingBottom: "24px",
                }}>Request the robot to deliver for you</Typography>
                </Box>
                <img src="./assets/calendar.png" alt="calendar" height={"150px"} style={{
                    bottom: "-15px",
                    position: "relative",
                    paddingRight: "36px"
                }}/>
            </Stack>
        </Box>
        <Box sx={{
            paddingLeft: "32px",
            paddingRight: "32px",
            overflow: "hidden",
        }}>
                {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                    <Stack direction="column" sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "30px"
                    }}>
                    <Box sx={{
                        paddingTop: "16px",
                        width: "100%"
                    }}>
                        <Typography sx={{
                            paddingBottom: "8px",
                            fontSize: "18px",
                            fontWeight: "bold"
                        }}>Select Destination</Typography>
                        <Box sx = {{
                            border: "1px solid #DEDEDE",
                            width: "100%px",
                            height: "127px",
                        }}>
                            {["WARD 14F", "WARD 11F"].map(loc => { 
                            // {["WARD 14F"].map(loc => {
                                return <Button variant={selectedWard === loc ?  "outlined" : "text"} sx = {{
                                                marginRight: "16px",
                                                marginTop: "16px",
                                                marginLeft: "16px",
                                                width: "150px",
                                                background: "#DAE3F3",
                                                ":hover": {
                                                    backgroundColor: "#DAE3F3",
                                                },
                                            }} onClick={() => handleOnClickWard(loc)} disableRipple >{loc}</Button>
                            })}
                        </Box>
                        <Typography sx={{
                            fontSize: "18px",
                            paddingTop: "24px",
                            fontWeight:"bold"
                        }}> Robot wait time at delivery location</Typography>
                        <Stack direction="row">
                            <Stack direction="row" sx={{
                                alignItems: "center",
                                justifyContent: "center", 
                                paddingRight: "30px"
                            }}>
                                <Radio onChange={handleOnClickRadio} value={"10"} checked={selectedTimeWait === "10"} />
                                <Typography> Wait 10 Minutes</Typography>
                            </Stack>
                            <Stack direction="row" sx={{
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <Radio value={"inf"} onChange={handleOnClickRadio} checked={selectedTimeWait === "inf"}/>
                                <Typography> Wait indefinitely</Typography>
                            </Stack>
                        </Stack>
                        <Button variant="text"  onClick={handleOnClickProceed} sx={{
                        // <Button variant="text"  onClick={handleSubmit} disabled={robotData?.robot_mode === RobotMode.MANUAL ? true : false}  sx={{
                            background: "#DAE3F3",
                            width: "100%",
                        }}> Proceed </Button>
                    </Box>
                    <Snackbar open={success} autoHideDuration={2000} onClose={handleClose}>
                        <Alert severity="success" sx={{ width: '100%' }} onClose={handleClose}>
                            Successfully called robot to current location!
                        </Alert>
                    </Snackbar>
                    <Snackbar open={failed} autoHideDuration={2000} onClose={handleClose}>
                        <Alert severity="error" sx={{ width: '100%' }} onClose={handleClose}>
                            Failed calling robot to current location, Please check your configurations!
                        </Alert>
                    </Snackbar>
                    </Stack>
                {/* </LocalizationProvider> */}
            </Box>
    </>
}